import { render, staticRenderFns } from "./event_item.vue?vue&type=template&id=50911fe4&"
import script from "./event_item.vue?vue&type=script&lang=js&"
export * from "./event_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports